(() => {
  const section = document.querySelector('[data-section]');
  const dialog = document.querySelector('[data-evidence-dialog]');
  const open = document.querySelector('[data-open-evidence]');
  const closers = document.querySelectorAll('[data-close-evidence]');
  const goAnswer = document.querySelector('[data-go-answer]');

  if (section) {
    const reveal = () => section.classList.add('is-visible');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          reveal();
          observer.disconnect();
        }
      }, { threshold: .24 });
      observer.observe(section);
    } else {
      reveal();
    }
  }

  const closeDialog = () => {
    if (dialog?.open) dialog.close();
  };

  open?.addEventListener('click', () => dialog?.showModal());
  closers.forEach((button) => button.addEventListener('click', closeDialog));
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  goAnswer?.addEventListener('click', () => {
    window.setTimeout(() => document.querySelector('#ec-sec-14')?.scrollIntoView({ behavior: 'smooth' }), 80);
  });

  const outcomes = document.querySelector('[data-atlas-outcomes]');
  const outcomeMarkers = [...document.querySelectorAll('[data-outcome-progress]')];
  const outcomeTitle = document.querySelector('[data-outcome-title]');
  const outcomeCopy = document.querySelector('[data-outcome-copy]');
  const outcomeCurrent = document.querySelector('[data-outcome-current]');
  const outcomeDefaults = [
    ['ENERGY.', 'A steadier foundation for the demands of your day.'],
    ['FOCUS.', 'Clearer intent when it is time to lock in and perform.'],
    ['STRENGTH.', 'Daily nutritional support for training, effort and recovery.'],
    ['MALE VITALITY.', 'Purpose-built support for drive, confidence and male wellbeing.']
  ];
  const outcomeData = outcomeDefaults.map((fallback, index) => {
    const key = index + 1;
    return [
      outcomes?.dataset[`outcome${key}Title`] || fallback[0],
      outcomes?.dataset[`outcome${key}Copy`] || fallback[1]
    ];
  });
  let activeOutcome = 0;
  let outcomeFrame = 0;

  const setOutcome = (index) => {
    const outcome = outcomeData[index];
    if (!outcome || !outcomes || index === activeOutcome) return;
    activeOutcome = index;
    outcomes.classList.add('is-changing');
    window.setTimeout(() => {
      outcomeMarkers.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      if (outcomeTitle) outcomeTitle.textContent = outcome[0];
      if (outcomeCopy) outcomeCopy.textContent = outcome[1];
      if (outcomeCurrent) outcomeCurrent.textContent = String(index + 1).padStart(2, '0');
      outcomes.classList.remove('is-changing');
    }, 170);
  };

  const updateOutcomeFromScroll = () => {
    outcomeFrame = 0;
    if (!outcomes) return;
    const rect = outcomes.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    if (rect.bottom <= 0) return setOutcome(3);
    if (rect.top >= viewportHeight) return setOutcome(0);

    const pinnedScene = outcomes.querySelector('.ec-atlas-outcomes__inner');
    const pinnedHeight = pinnedScene?.getBoundingClientRect().height || viewportHeight;
    const scrollableDistance = Math.max(rect.height - pinnedHeight, 1);
    const progress = Math.min(1, Math.max(0, -rect.top / scrollableDistance));
    setOutcome(Math.min(3, Math.floor(progress * 4)));
  };

  const requestOutcomeUpdate = () => {
    if (outcomeFrame) return;
    outcomeFrame = window.requestAnimationFrame(updateOutcomeFromScroll);
  };

  window.addEventListener('scroll', requestOutcomeUpdate, { passive: true });
  window.addEventListener('resize', requestOutcomeUpdate);
  requestOutcomeUpdate();

  const formulaDialog = document.querySelector('[data-formula-dialog]');
  const formulaOpen = document.querySelectorAll('[data-open-formula]');
  const formulaClosers = document.querySelectorAll('[data-close-formula]');
  const closeFormula = () => {
    if (formulaDialog?.open) formulaDialog.close();
  };

  formulaOpen.forEach((button) => button.addEventListener('click', () => formulaDialog?.showModal()));
  formulaClosers.forEach((button) => button.addEventListener('click', closeFormula));
  formulaDialog?.addEventListener('click', (event) => {
    if (event.target === formulaDialog) closeFormula();
  });

  const researchDialog = document.querySelector('[data-research-dialog]');
  const researchOpen = document.querySelector('[data-open-research]');
  const researchClosers = document.querySelectorAll('[data-close-research]');
  const closeResearch = () => {
    if (researchDialog?.open) researchDialog.close();
  };

  researchOpen?.addEventListener('click', () => researchDialog?.showModal());
  researchClosers.forEach((button) => button.addEventListener('click', closeResearch));
  researchDialog?.addEventListener('click', (event) => {
    if (event.target === researchDialog) closeResearch();
  });

  const atlasReportDialog = document.querySelector('[data-atlas-report-dialog]');
  const atlasReportOpen = document.querySelector('[data-open-atlas-report]');
  const atlasReportClosers = document.querySelectorAll('[data-close-atlas-report]');
  const closeAtlasReport = () => {
    if (atlasReportDialog?.open) atlasReportDialog.close();
  };

  atlasReportOpen?.addEventListener('click', () => atlasReportDialog?.showModal());
  atlasReportClosers.forEach((button) => button.addEventListener('click', closeAtlasReport));
  atlasReportDialog?.addEventListener('click', (event) => {
    if (event.target === atlasReportDialog) closeAtlasReport();
  });

  const trustDialog = document.querySelector('[data-atlas-trust-dialog]');
  const trustOpeners = document.querySelectorAll('[data-open-trust-detail]');
  const trustClosers = document.querySelectorAll('[data-close-trust-detail]');
  const trustTitle = document.querySelector('[data-trust-dialog-title]');
  const trustBody = document.querySelector('[data-trust-dialog-body]');
  const trustLink = document.querySelector('[data-trust-dialog-link]');
  const trustCta = document.querySelector('[data-trust-dialog-cta]');
  const closeTrust = () => {
    if (trustDialog?.open) trustDialog.close();
  };

  trustOpeners.forEach((button) => button.addEventListener('click', () => {
    if (trustTitle) trustTitle.textContent = button.dataset.trustTitle || '';
    if (trustBody) trustBody.textContent = button.dataset.trustBody || '';
    if (trustLink) trustLink.href = button.dataset.trustTarget || '#ec-sec-16';
    if (trustCta) trustCta.textContent = button.dataset.trustCta || 'Inspect the evidence';
    trustDialog?.showModal();
  }));

  trustClosers.forEach((button) => button.addEventListener('click', closeTrust));
  trustDialog?.addEventListener('click', (event) => {
    if (event.target === trustDialog) closeTrust();
  });
  trustLink?.addEventListener('click', closeTrust);

  const routine = document.querySelector('[data-atlas-routine]');
  const routineSteps = [...document.querySelectorAll('[data-routine-step]')];
  const routineTipTitle = document.querySelector('[data-routine-tip-title]');
  const routineTipBody = document.querySelector('[data-routine-tip-body]');

  if (routine) {
    if ('IntersectionObserver' in window) {
      const routineObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          routine.classList.add('is-visible');
          routineObserver.disconnect();
        }
      }, { threshold: .2 });
      routineObserver.observe(routine);
    } else {
      routine.classList.add('is-visible');
    }
  }

  routineSteps.forEach((button) => button.addEventListener('click', () => {
    routineSteps.forEach((step) => {
      const selected = step === button;
      step.classList.toggle('is-active', selected);
      step.setAttribute('aria-expanded', String(selected));
    });
    if (routineTipTitle) routineTipTitle.textContent = button.dataset.tipTitle || '';
    if (routineTipBody) routineTipBody.textContent = button.dataset.tipBody || '';
  }));

  const supply = document.querySelector('[data-atlas-supply]');
  const supplyValues = [...document.querySelectorAll('[data-supply-value]')];
  let supplyAnimated = false;

  const revealSupply = () => {
    if (!supply || supplyAnimated) return;
    supplyAnimated = true;
    supply.classList.add('is-visible');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const startedAt = performance.now();
    const duration = 720;
    const update = (now) => {
      const progress = Math.min(1, (now - startedAt) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      supplyValues.forEach((node) => {
        const target = Number(node.dataset.supplyValue || 0);
        node.textContent = String(Math.round(target * eased));
      });
      if (progress < 1) window.requestAnimationFrame(update);
    };
    supplyValues.forEach((node) => { node.textContent = '0'; });
    window.requestAnimationFrame(update);
  };

  if (supply) {
    if ('IntersectionObserver' in window) {
      const supplyObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          revealSupply();
          supplyObserver.disconnect();
        }
      }, { threshold: .28 });
      supplyObserver.observe(supply);
    } else {
      revealSupply();
    }
  }

  const offer = document.querySelector('[data-atlas-offer]');
  if (offer) {
    if ('IntersectionObserver' in window) {
      const offerObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          offer.classList.add('is-visible');
          offerObserver.disconnect();
        }
      }, { threshold: .18 });
      offerObserver.observe(offer);
    } else {
      offer.classList.add('is-visible');
    }
  }
})();
